import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService } from '../../../tms-shared';
import { TmsWebBaseChartService } from '../base';
import { ChartWeeksPurchaseOrders } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ChartWeeksPurchaseOrdersService extends TmsWebBaseChartService<ChartWeeksPurchaseOrders> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService) {
    super('ChartWeeksPurchaseOrders', httpService);
  }
}
